import { Component } from '@angular/core';
import { SharedService } from '../../services/shared.service';

import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-custom-spinner',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './custom-spinner.component.html',
  styleUrl: './custom-spinner.component.scss',
})
export class CustomSpinnerComponent {
  constructor(public sharedService: SharedService) {}
}
